import React from "react";
import { Button, message, Layout } from 'antd';
import getSize from "../../utils/getSize";
import NHFetch from "../../utils/NHFetch";
import NHTable from '../common/NHTable';
import { NHConfirm } from '../common/NHModal';
import NHContainerFrame from '../common/NHContainerFrame';
import EditForm from './EditForm.js';
import NHTree from '../common/NHTree/index';
import ShowTable from './show'
import { hasAuth } from '../../utils/NHCore';
import NHModal from "../common/NHModal";
import PassWordForm from "./passWordForm";
const { Content } = Layout;



const basicUrl = "/newStudent"; //基础路径

/**
 * 新生管理列表
 * @author Xiafanglin
 * @date 2018-03-07 09:29:32
 * Version: 1.0
 */
class NewStudentMng extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            frameVisibleMap: {
                tableFlag: true,
                addFlag: false,
                showFlag: false,
            },
            searchParams: {},
            showOperationBtn: false,
            showData: {},
            availableStudentNumber: 0,
            disabledStudentNumber: 0,
            studentCount: 0,
        };
    }

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }

    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }

    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setCurrentPageShow('addFlag');
    }

    //打开内嵌时间
    handleOpenFrame = (record) => {
        this.setState({
            showData: record
        });
        this.setCurrentPageShow('showFlag');
    }

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
        NHConfirm("是否确定删除这条数据？", () => {
            let pkid = record.PKID;
            this.handleDelete([pkid]);
        }, "warn");
    }

    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            NHConfirm("是否确定删除选中的多条数据？", () => {
                this.handleDelete(selectedRowKeys);
            }, "warn");
        } else {
            message.warning("请先选择需要删除的数据！");
        }
    }

    //删除操作
    handleDelete = (pkids) => {
        NHFetch(basicUrl + '/deleteByMulti', 'POST', pkids)
            .then(res => {
                if (res) {
                    message.success("删除操作成功！");
                    this.refs.nhTable.filterTableData();
                }
            })
    }

    //统计范围选择
    onChangeValue = (value) => {

        this.form.validateFields((err, formData) => {

            if (err) {
                return;
            }

            let data = formData;
            for (let key of Object.keys(value)) {
                data[key] = value[key];
            }

            NHFetch(basicUrl + '/getStudentNumOnRange', 'POST', data)
                .then(res => {
                    if (res && res.data) {
                        const disabledStudentNumber = res.data['DISABLEDSTUDENTNUMBER'];
                        const availableStudentNumber = res.data['AVAILABLESTUDENTNUMBER'];
                        this.setState({ availableStudentNumber: availableStudentNumber, disabledStudentNumber: disabledStudentNumber });
                    }
                })
        });

    }

    //新增面板保存方法
    handleSaveAdd = () => {
        this.form.validateFields((err, formData) => {
            if (err) {
                return;
            }
            if (formData.cqfs == 1) {
                formData['xsids'] = undefined;

                if (!formData.rxnf && (!formData.bmids || formData.bmids.length <= 0) && !formData.xslbm) {
                    NHConfirm("请至少选择一项筛选条件！");
                    return;
                }
            } else if (formData.lqfs == 2) {
                if (!formData.xsids || formData.xsids.length <= 0) {
                    NHConfirm("请至少选择一个学生！");
                    return;
                }
            }

            NHConfirm("确认新增迎新学生？", () => {

                NHFetch(basicUrl + '/insertByFilterParams', 'POST', formData)
                    .then(res => {
                        if (res && res.data != null) {
                            message.success("新增迎新学生成功！");
                            this.setCurrentPageShow('tableFlag');
                            this.refs.nhTable.filterTableData();
                            this.setState({ disabledStudentNumber: 0, availableStudentNumber: 0 });
                        } else {
                            message.error('新增迎新学生失败，请重试！');
                        }
                    });
            }, 'warn');
        });
    }

    // table选择后出现操作按钮
    rowSelectionChange = (selectedRowKeys) => {
        //学生数量
        this.setState({
            studentCount: selectedRowKeys.length
        });

        if (selectedRowKeys.length) {
            this.setState({
                showOperationBtn: true
            })
        } else {
            this.setState({
                showOperationBtn: false
            })
        }
    }

    //树checkbox选中回调函数
    checkedTreeNode = (selectKeys, e) => {
        let searchParams = this.state.searchParams;
        let bmids = [];
        let zyids = [];
        let bjids = [];
        for (var index = 0; index < selectKeys.length; index++) {
           if (e[index].dataRef.level == 2) {
                   bmids.push(selectKeys[index]);
                } else if (e[index].dataRef.level == 3) {
                    zyids.push(selectKeys[index]);
                } else if (e[index].dataRef.level == 4) { 
                    bjids.push(selectKeys[index]);
                }
           
        }
        let map = {};
        if (bmids && bmids.length > 0) {
            map["S_bmid_IN"] = bmids;
        }
        if (zyids && zyids.length > 0) {
            map["S_zyid_IN"] = zyids;
        }
        if (bjids && bjids.length > 0) {
            map["S_bjid_IN"] = bjids;
        }
        searchParams["map"] = map;
        this.setState({
            searchParams: searchParams
        });
        this.refs.nhTable.filterTableData();
    }

    //密码修改
    handleUpdatePassWordBtnClick = () => {
        this.refs.nhUpdatePassWord.show();
    }

    //初始化密码
    handleInitPassWordBtnClick = () => {
        this.refs.nhInitPassWord.show();
    }

    //修改密码
    saveUpdatePassWord = () => {
        let selectedRows = this.refs.nhTable.state.selectedRows;
        let xsids = [];
        if (selectedRows && selectedRows.length > 0) {
            selectedRows.map((elem, index) => {
                xsids.push(elem['XSID'])
            })
        } else {
            message.warn("抱歉！未获取到学生数据，请刷新后再试。")
        }
        this.updatePassWord.validateFields((err, formData) => {
            if (err) {
                return;
            }
            console.log('数据',formData)
            let left = formData['left'];
            let right = formData['right'];
            let sfzjh = formData['sfzjh'];
            if (left || right || (sfzjh && sfzjh > 0)) {

            } else {
                this.updatePassWord.setFields({
                    left: {
                        value: '',
                        errors: [new Error('密码填写或身份证位数不能同时为空。')],
                    },
                });
                this.refs.nhUpdatePassWord.stopLoading();
                return;
            }
            let params = formData;
            formData['xsids'] = xsids;
            NHConfirm("确认修改选择的学生密码？", () => {

                NHFetch(basicUrl + '/saveUpdatePassWord', 'POST', formData)
                    .then(res => {
                        //后端对应接口的返回值改了，所以整理也要修改下逻辑
                        // if (res && res.data != null && res.data > 0) {
                        //     message.success("修改学生密码成功！本次修改人数为：" + res.data);
                        //     this.setCurrentPageShow('tableFlag');
                        //     this.refs.nhUpdatePassWord.close();
                        //     this.refs.nhTable.filterTableData();
                        // }else if(res && res.data != null && res.data == -1){
                        //     message.error('身份证件号为空，修改失败！');
                        //     this.refs.nhInitPassWord.stopLoading();
                        // } else {
                        //     message.error('修改密码失败，请重试！');
                        //     this.refs.nhUpdatePassWord.stopLoading();
                        // }
                        if (res && res.data != null){
                            if(res.data > 0 || res.data === -1){
                                message.success("修改学生密码成功！本次修改人数为：" +xsids.length);
                                this.setCurrentPageShow('tableFlag');
                                this.refs.nhUpdatePassWord.close();
                                this.refs.nhTable.filterTableData();
                            }else if(res.data === -2){
                                message.error('身份证件号为空，修改失败！');
                                this.refs.nhInitPassWord.stopLoading();
                            }else{
                                message.error('修改密码失败，请重试！');
                                this.refs.nhUpdatePassWord.stopLoading();
                            }
                        }

                    }).catch(err => {
                        this.refs.nhUpdatePassWord.stopLoading();
                    });

            }, 'warn', () => {
                this.refs.nhUpdatePassWord.stopLoading();
            });

        });
    }

    //初始化密码
    savdIntiPassWord = (stopLoading) => {
        this.initPassWord.validateFields((err, formData) => {
            if (err) {
                return;
            }

            let left = formData['left'];
            let right = formData['right'];
            let sfzjh = formData['sfzjh'];
            if (left || right || (sfzjh && sfzjh > 0)) {

            } else {
                this.initPassWord.setFields({
                    left: {
                        value: '',
                        errors: [new Error('密码填写或身份证位数不能同时为空。')],
                    },
                });
                this.refs.nhInitPassWord.stopLoading();
                return;
            }

            NHConfirm("确认初始化新生密码？", () => {

                NHFetch(basicUrl + '/savdIntiPassWord', 'POST', formData)
                    .then(res => {
                        if (res && res.data != null && res.data > 0) {
                            message.success("修改学生密码成功！本次修改人数为：" + res.data);
                            this.refs.nhInitPassWord.close();
                            this.setCurrentPageShow('tableFlag');
                            this.refs.nhTable.filterTableData();
                        } else if (res && res.data != null && res.data == 0) {
                            message.warn('本次密码修改人数未0,请检查选择范围');
                            this.refs.nhUpdatePassWord.stopLoading();
                            stopLoading();
                        }else if(res && res.data != null && res.data == -1){
                            message.error('身份证件号为空，初始化失败！');
                            this.refs.nhInitPassWord.stopLoading();
                            stopLoading();
                        } else {
                            message.error('初始密码失败，请重试！');
                            this.refs.nhInitPassWord.stopLoading();
                            stopLoading();
                        }
                    }).catch(err => {
                        this.refs.nhInitPassWord.stopLoading();
                    });

            }, 'warn', () => {
                this.refs.nhInitPassWord.stopLoading();
            });
        });
    }


    render() {

        //列参数
        const columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '60px',
            }, {
                title: '年度',
                dataIndex: 'ND',
                width: '70px',
                searchType:"select"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '90px',
                search: 'input',
                searchType:"input"
            }, {
                title: '性别',
                dataIndex: 'XB',
                width: '70px',
                searchType:"select"
            }, {
                title: '入学年份',
                dataIndex: 'RXNF',
                width: '110px',
                searchType:"select"
            }, {
                title: '身份证件类型',
                dataIndex: 'SFZJLX',
                width: '130px'
            }, {
                title: '身份证件号',
                dataIndex: 'SFZJH',
                width: '180px',
                searchType:"input"
            }, {
                title: '考生号',
                dataIndex: 'KSH',
                width: '140px',
                searchType:"input"
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '140px',
                search: 'input',
                searchType:"input"
            }, {
                title: '校区',
                dataIndex: 'XQMC',
                width: '100px',
                searchType:"select"
            }, {
                title: '院系',
                dataIndex: 'BMMC',
                width: '150px',
                searchType:"select"
            }, {
                title: '专业',
                dataIndex: 'ZYMC',
                width: '150px',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                dataIndex: 'BJMC',
                width: '160px',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '手机号码',
                dataIndex: 'SJHM',
                width: '120px',
                searchType:"input"
            }, {
                title: '政治面貌',
                dataIndex: 'ZZMM',
                width: '120px',
                searchType:"select"
            }, {
                title: '民族',
                dataIndex: 'MZ',
                width: '100px',
                searchType:"input"
            }, {
                title: '籍贯',
                dataIndex: 'JG',
                width: '150px',
                searchType:"input"
            }, {
                title: '生源地',
                dataIndex: 'SYD',
                width: '150px',
                searchType:"input"
            }, {
                title: '学生类别',
                dataIndex: 'XSLB',
                width: '120px',
                searchType:"select"
            }, {
                title: '学生来源',
                dataIndex: 'XSLY',
                width: '120px',
                searchType:"select"
            }
        ];
        // 行内操作
        const action = [
            { title: '查看详情', onClick: this.handleOpenFrame, auth: 'zhxg_yxgl_jcsj_xssjgl:detail' },
            { title: '删除', onClick: this.handleSingleDeleteBtnClick, auth: 'zhxg_yxgl_jcsj_xssjgl:delete' },
        ];

        const { frameVisibleMap, availableStudentNumber, disabledStudentNumber } = this.state;

        return (
            <Layout style={{ height: '100%' }}>
                <div style={{display: frameVisibleMap.tableFlag ? "block" : "none"}}>
                    <Layout>
                        {/* <NHTree ref='nhTree' sign={"zhxg_class"} checkedTreeNode={this.checkedTreeNode} /> */}
                        <Layout >
                            <Content >
                                <div style={{ margin: '12px', marginBottom: '0px', padding: '16px', background: '#fff', height: getSize().windowH - 123, overflow: 'hidden' }}>
                                    <NHTable ref='nhTable'
                                        rowKey={record => record.PKID}
                                        sign={"zhxg_yxxt_newStudent_queryPage"}
                                        columns={columns}
                                        initParams={this.state.searchParams}
                                        rowSelectionChange={this.rowSelectionChange}
                                        action={action}
                                        rangeFilter={true}>
                                        {
                                            hasAuth('zhxg_yxgl_jcsj_xssjgl:add') ?
                                                <Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>
                                                : null
                                        }
                                        {
                                            hasAuth('zhxg_yxgl_jcsj_xssjgl:delete') ?
                                                (
                                                    this.state.showOperationBtn &&
                                                    <Button type="danger" ghost style={{ marginLeft: 10 }} onClick={this.handleMultiDeleteBtnClick}>删除</Button>
                                                )
                                                : null
                                        }
                                        {
                                            hasAuth('zhxg_yxgl_jcsj_xssjgl:updatPassWord') ?
                                                (
                                                    this.state.showOperationBtn &&
                                                    <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleUpdatePassWordBtnClick}>修改密码</Button>
                                                )
                                                : null
                                        }
                                        {
                                            hasAuth('zhxg_yxgl_jcsj_xssjgl:initPassWord') ?
                                                <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleInitPassWordBtnClick}>密码初始化</Button>
                                                : null
                                        }

                                    </NHTable>
                                </div>
                            </Content>
                        </Layout>
                    </Layout>
                </div>
                
                <NHModal ref="nhUpdatePassWord"
                    title="密码修改"
                    width={620}
                    onOk={this.saveUpdatePassWord}
                >
                    <PassWordForm studentCount={this.state.studentCount} isInit={false} ref={(form) => { this.updatePassWord = form }} />
                </NHModal>

                <NHModal ref="nhInitPassWord"
                    title="初始化密码"
                    width={620}
                    onOk={this.savdIntiPassWord}
                >
                    <PassWordForm studentCount={0} isInit={true} ref={(form) => { this.initPassWord = form }} />
                </NHModal>
                <NHContainerFrame
                    ref="nhAddModal"
                    style={{ margin: '12px 12px 0 12px', padding: '16px', background: '#fff' }}
                    title={"添加学生至迎新管理"}
                    visible={this.state.frameVisibleMap.addFlag}
                    onOk={this.handleSaveAdd}
                    onCancel={this.handleCloseFrame}
                >
                    <EditForm
                        ref={(form) => { this.form = form }}
                        availableStudentNumber={availableStudentNumber}
                        disabledStudentNumber={disabledStudentNumber}
                        onChange={this.onChangeValue}
                        initFunc={this.onChangeValue}
                    />
                </NHContainerFrame>
                <NHContainerFrame
                    style={{ margin: '12px 12px 0 12px', padding: '16px', background: '#fff' }}
                    title={"学生详情"}
                    visible={this.state.frameVisibleMap.showFlag}
                    footer={[]}
                    onCancel={this.handleCloseFrame}
                >
                    <ShowTable showData={this.state.showData} />
                </NHContainerFrame>
            </Layout >
        );
    }
}
export default NewStudentMng;



// WEBPACK FOOTER //
// ./components/newStudentMng/newStudentMng.js